<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
        <div slot="modal-title">
            Meta -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="5">
                <b-form-group>
                    <label class="required">Tipos de Instrumento</label>
                    <b-input-group>
                        <b-form-select
                            type="text"
                            :options="tiposInstrumento"
                            text-field="descCategoria"
                            value-field="codCategoria"
                            v-model="codCategoria">
                        </b-form-select>
                        <b-form-invalid-feedback>O Tipo de Instrumento da meta é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="6">
                <b-form-group>
                    <label class="required">Quantidade</label>
                    <b-input-group>
                        <b-form-input
                            type="number"
                            v-model="quantidade"
                        ></b-form-input>
                        <b-form-invalid-feedback>A quantidade é obrigatória.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="6">
                <b-form-group>
                    <label>Quantidade de horas totais</label>
                    <b-input-group>
                        <b-form-input
                            type="number"
                            v-model="quantidadeHorasTotais"
                        ></b-form-input>
                        <b-form-invalid-feedback>A quantidade de horas totais é obrigatória.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="6">
                <b-form-group>
                    <label class="required">Pequenos negócios inscritos</label>
                    <b-input-group>
                        <b-form-input
                            type="number"
                            v-model="pequenosNegociosInscritos"
                        ></b-form-input>
                        <b-form-invalid-feedback>Os pequenos negócios são obrigatórios</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="6">
                <b-form-group>
                    <label>Número de pessoas físicas</label>
                    <b-input-group>
                        <b-form-input
                            type="number"
                            v-model="numeroPessoasFisicas"
                        ></b-form-input>
                        <b-form-invalid-feedback>O Número de pessoas físicas é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        acao: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        },
        dataServicos: {
            type: Object
        },
    },

    validations: {
        codCategoria: {
            required
        },
        quantidade: {
            required,
            minValue: minValue(0.1)
        },
        pequenosNegociosInscritos: {
            required,
            minValue: minValue(0.1)
        },
    },

    data() {
        return {
            codCategoria: null,
            tiposInstrumento: [],
            quantidade: null,
            operacaoProp: 'INSERÇÃO',
            quantidadeHorasTotais: null,
            pequenosNegociosInscritos: null,
            numeroPessoasFisicas: null,
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    methods: {
        preencher() {
            this.obterTiposInstrumento()
            // if (this.operacaoProp == 'A') {
            //     this.nomeAcao = this.acao.nomeAcao
            //     this.dataInicio = this.acao.dataInicio
            //     this.dataFim = this.acao.dataFim
            //     this.codUnidade = this.acao.vcCodUnidade
            // }
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar(){
            this.codCategoria = null
            this.quantidade = null
            this.quantidadeHorasTotais = null
            this.pequenosNegociosInscritos = null
            this.numeroPessoasFisicas = null
        },

        obterTiposInstrumento() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterTiposInstrumento().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.tiposInstrumento = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        salvar() {
            let metaDto = {
                acaoId: this.acao.acaoId,
                codCategoria: this.codCategoria,
                quantidade: this.quantidade,
                quantidadeHorasTotais: this.quantidadeHorasTotais  != null ? this.quantidadeHorasTotais : 0,
                pequenosNegociosInscritos: this.pequenosNegociosInscritos,
                numeroPessoasFisicas: this.numeroPessoasFisicas != null ? this.numeroPessoasFisicas : 0
            }
            this.$emit('salvar', metaDto)
            this.fecharModal()
        },
    },
}
</script>
